import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-15346c60"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container-xl" };
const _hoisted_2 = { class: "table-responsive" };
const _hoisted_3 = { class: "table-wrapper" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "table-title" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "row" }, [
        /*#__PURE__*/ _createElementVNode("div", null, [
            /*#__PURE__*/ _createTextVNode("Edit > "),
            /*#__PURE__*/ _createElementVNode("b", null, "About")
        ])
    ])
], -1));
const _hoisted_5 = { class: "content_edit" };
const _hoisted_6 = { class: "input-group" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "input-group-text" }, "Text", -1));
const _hoisted_8 = { class: "aligned" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "adding_item" }, "Save", -1));
const _hoisted_10 = [
    _hoisted_9
];
import 'vue-final-modal/style.css';
import '../../assets/styles/boot.min.css';
import '../../assets/styles/font.min.css';
import { ref, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import api from '../../api';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditorAbout',
    props: {
        title: String,
        item: null
    },
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const props = __props;
        const name = ref('');
        const isAble = ref(false);
        console.log(props.item);
        console.log(router, route);
        // Fetch users data
        const fetchPage = async () => {
            console.log('fecth');
            try {
                const response = await api.get('page_list.php', {
                    params: { cat: "About" }
                });
                console.log(response.data);
                if (response.data[0])
                    name.value = response.data[0].main;
            }
            catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchPage();
        const change = async () => {
            try {
                const formData = new FormData();
                formData.append('id', "1");
                formData.append('main', name.value);
                console.log(formData);
                const response = await api.post('edit_page.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                if (response.data.status === 'success') {
                    console.log('Page edit successfully');
                    // Refresh user list or handle success
                }
                else {
                    console.error('Error edit user:', response.data.message);
                }
            }
            catch (error) {
                console.error('Request error:', error);
            }
        };
        // Watch the `name` ref and update `isAble` accordingly
        watch(name, (newName, oldName) => {
            console.log(newName, oldName);
            if (newName === "") {
                isAble.value = false;
            }
            else {
                isAble.value = true;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _withDirectives(_createElementVNode("textarea", {
                                    class: "form-control",
                                    "aria-label": "With textarea",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((name).value = $event)),
                                    rows: "10"
                                }, null, 512), [
                                    [_vModelText, name.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("button", {
                                    class: _normalizeClass([isAble.value ? '' : 'disabled', "btn btn-primary btn-block confirm_btn"]),
                                    onClick: change
                                }, _hoisted_10, 2)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
